import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Images from "../../constant/images";
import {  useNavigate } from "react-router-dom";
import "./Header.scss";
import { useAppSelector } from "../../redux/hooks";
import { AuthRouter, RouterList } from "../../router/Router";
import { Typography } from "@mui/material";



function Hader() {
  const navigate = useNavigate(); // Initialize the useNavigate hook


  

  const { token, userDetail: { profilePic = null, firstName = "", lastName= "", roles = {name: ''} } = {} } =
    useAppSelector((state: any) => state.auth);

  const handleUserEdit = () => {
    navigate(AuthRouter[1].subpath);
  };


  return (
    <AppBar position="fixed" className="appbar" data-testid="header">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              flexGrow: 1,
              display: { md: "flex" },
              gap: "30px",
              cursor: "pointer",
            }}
          >
            <img
              src={Images.logo}
              alt="Riverbed"
              className="Riverbed"
              onClick={() => navigate(RouterList[0].path)}
            ></img>
            <img
              src={Images.loginlogo}
              alt="ROI Navigator"
              className="ROI-Navigator"
              onClick={() => navigate(RouterList[0].path)}
            ></img>
          </Box>
           {token ? (
            <Box className="MuiContainer-root" display={"flex"} alignItems="center">
              <Tooltip title="Edit Profile">
                <Box onClick={handleUserEdit} display={"flex"} alignItems="center" gap={"20px"}>
                  {!profilePic ? (
                    <Avatar
                      alt={firstName?.toLocaleUpperCase()}
                      src="/static/images/avatar/default.jpg"
                    />
                  ) : (
                    <img
                      className="profile-pic"
                      src={`${process.env.REACT_APP_IMAGE_URL}${profilePic}`}
                      alt="profilePics"
                    />
                  )}
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    <Typography variant="body1"fontWeight={600}>{`${firstName} ${lastName}`}</Typography>
                    <Typography variant="body2">{roles?.name}</Typography>
                  </Box>
                </Box>
              </Tooltip>
            </Box>
          ) : null}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Hader;
